import { ControlState } from '../../../types/control-state.interface';
import { createSlice } from '@reduxjs/toolkit';
import { InternshipStatus } from '../../InternshipStatus/InternshipStatus.type';
import { RootState } from '../../store';
import { getInternshipStatusControlThunk } from './InternshipStatusControl.thunk';

const SLICE_NAME = 'internshipStatus';

const initialState: ControlState<InternshipStatus> = {
  items: [],
  isLoading: false,
}

export const internshipStatusControlSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    setInternshipStatusControlList: (state, action) => ({
      ...state,
      items: action.payload,
    }),
  },
  extraReducers: builder => {
    builder.addCase(getInternshipStatusControlThunk.pending, state => {
      state.isLoading = true;
    });
    builder.addCase(
      getInternshipStatusControlThunk.fulfilled,
      (state, { payload }) => {
        const { data, pagination } = payload;
        state.isLoading = false;
        state.items = data;
        state.pagination = {
          currentPage: pagination.current_page,
          lastPage: pagination.last_page,
          perPage: pagination.per_page,
          from: pagination.from,
          to: pagination.to,
          total: pagination.total,
        };
      },
    );
    builder.addCase(getInternshipStatusControlThunk.rejected, state => {
      state.isLoading = false;
    });
  }
})

export const {
  setInternshipStatusControlList
} = internshipStatusControlSlice.actions;

export const getInternshipStatusControlList = (state: RootState) =>
  state.internshipStatusControl.items

export const getInternshipStatusControlListPagination = (state: RootState) =>
  state.internshipStatusControl.pagination

export default internshipStatusControlSlice.reducer
